import { Button, MessageTooltip, useStyles } from '@archipro-design/aria';
import type { SvgIconProps } from '@archipro-design/icons';
import type { Actions } from 'ahooks/lib/useBoolean';
import type { ReactElement } from 'react';
import * as S from './PinOverlayButtons.style';

interface PinOverlayButtonProps {
    open: boolean;
    onClick: (e: React.SyntheticEvent<HTMLElement>) => void;
    icon: ReactElement<SvgIconProps, 'svg'>;
    booleanActions: Actions;
    toolTipText: string;
    link?: string;
    className?: string;
    linkParams?: {};
}

const PinOverlayButton = ({
    open,
    onClick,
    icon,
    booleanActions,
    toolTipText,
    link,
    className,
    linkParams,
}: PinOverlayButtonProps) => {
    const { css } = useStyles();

    return (
        <MessageTooltip
            open={open}
            trigger={
                <Button
                    className={className}
                    icon={icon}
                    size={18}
                    color="grey"
                    variables={{ buttonPadding: 4 }}
                    onClick={onClick}
                    onMouseEnter={booleanActions.setTrue}
                    onMouseLeave={booleanActions.setFalse}
                    onMouseDown={booleanActions.setFalse}
                    {...(link && {
                        as: 'a',
                        href: link,
                        target: '_blank',
                    })}
                    {...linkParams}
                />
            }
            content={{
                children: toolTipText,
                size: 16,
                padding: 8,
                className: css(S.ToolTipText),
            }}
            position="above"
            offset={[0, 9]}
        />
    );
};

export default PinOverlayButton;
